import React from 'react';
import { Text } from 'library';
import download from 'shared/Download';
import { track } from 'shared';
import { Provider } from 'models';

interface ILinkItem {
    type: string;
    url: string;
    text: string;
}

export async function downloadFile(path: string) {
    try {
        await download(path);
    } catch (error) {
        track('Document Download Error:', error);
    }
}

export function getLinks(provider: Provider) {
    const medRecords = provider.medical_record;
    const educationRecords = provider.hs_education_record;
    const occrraInfo = provider.occrra_info;

    const medRecordLinks = medRecords
        ?.filter((x) => x.verified_at)
        .map((x) => {
            return { type: 'download', text: 'Signed Medical Form', url: `api/md-records/${x.id}/download/` };
        });

    const educationLinks = educationRecords
        ?.filter((x) => x.verified_at)
        .map((x) => {
            return {
                type: 'download',
                text: 'HS Education Verification',
                url: x.url,
            };
        });

    const links = [...(medRecordLinks || []), ...(educationLinks || [])];

    if (occrraInfo?.background_check_link) {
        links.push({ type: 'link', text: 'FBI/BCI Background Check', url: occrraInfo.background_check_link });
    }

    if (provider?.documents) {
        provider?.documents.forEach((doc: any) => {
            links.push({ type: 'link', text: doc.title, url: doc.document });
        });
    }

    if (provider?.user.resume) {
        links.push({ type: 'link', text: 'Resume', url: provider.user.resume.document });
    }
    return links;
}

export default function DocumentLinks({ provider }: { provider: Provider }) {
    let links = getLinks(provider);

    const getLink = (item: ILinkItem) => {
        if (item.type === 'download') {
            const onClick = (e: any) => {
                downloadFile(item.url);
                e.preventDefault();
            };
            return (
                <a href={item.url} onClick={onClick}>
                    {item.text}
                </a>
            );
        }

        return (
            <a target="_blank" rel="noreferrer" href={item.url}>
                {item.text}
            </a>
        );
    };

    const displayDocuments = () => {
        if (!links.length) {
            return <Text variant="body2">There are no documents to show for this provider.</Text>;
        }

        return (
            <div>
                {links.map((x) => (
                    <div key={x.url}>• {getLink(x)}</div>
                ))}
            </div>
        );
    };

    return displayDocuments();
}
